import { Icon } from '@/components/Icon';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import type { Assertion } from './profileFormModel';
import type { ProfileFormApi } from './useProfileForm';

/** One key / pattern pair (the key is normalised to an env var name as it is typed). */
function AssertionRow({ assertion, index, form }: { assertion: Assertion; index: number; form: ProfileFormApi }) {
  return (
    <div className="grid grid-cols-[minmax(0,1fr)_minmax(0,1.4fr)_auto] gap-2">
      <Input data-testid="profile-assertion-key" value={assertion.key} onChange={(e) => form.setAssertionKey(index, e.target.value)} placeholder="EXPO_PUBLIC_API_URL" className="font-mono sm:text-[13px]" spellCheck={false} aria-label="Assertion key" />
      <Input data-testid="profile-assertion-pattern" value={assertion.pattern} onChange={(e) => form.setAssertionPattern(index, e.target.value)} placeholder="^https://api\.(staging\.)?example\.com/" className="font-mono sm:text-[13px]" spellCheck={false} aria-label="Assertion pattern" />
      <Button type="button" variant="ghost" size="icon" aria-label="Remove assertion" className="text-subtle" onClick={() => form.removeAssertion(index)}>
        <Icon name="delete" size={18} />
      </Button>
    </div>
  );
}

/** Env assertions: baked values checked against a pattern after the build. */
export function ProfileAssertions({ form }: { form: ProfileFormApi }) {
  const { assertions } = form.values;
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center justify-between">
        <Label className="text-[13px]">Env assertions</Label>
        <Button type="button" variant="ghost" size="sm" data-testid="profile-assertion-add" onClick={form.addAssertion}>
          <Icon name="add" size={16} />
          Add
        </Button>
      </div>
      {assertions.length === 0 ? <p className="text-xs text-subtle">Baked values are checked against a pattern after the build (HGR-CHECK-ENV).</p> : null}
      {assertions.map((a, i) => (
        <AssertionRow key={i} assertion={a} index={i} form={form} />
      ))}
    </div>
  );
}
